var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEyeGalleryOpen = function SvgEyeGalleryOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eyeGalleryOpen_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.27 12.031c.203.406.355.813.355 1.219 0 .457-.152.863-.355 1.219-1.473 2.488-3.454 4.469-5.942 5.89-2.539 1.524-5.332 2.235-8.328 2.235-3.047 0-5.79-.711-8.328-2.235A15.403 15.403 0 0 1 .73 14.47c-.253-.356-.355-.762-.355-1.219 0-.406.102-.813.355-1.219 1.422-2.437 3.403-4.418 5.942-5.89C9.21 4.668 11.953 3.906 15 3.906c2.996 0 5.79.762 8.328 2.235a16.926 16.926 0 0 1 5.942 5.89ZM15 20.156c2.54 0 4.926-.61 7.059-1.879a13.912 13.912 0 0 0 5.128-5.027 16.846 16.846 0 0 0-2.894-3.402 13.554 13.554 0 0 0-3.809-2.438c.914 1.27 1.422 2.692 1.422 4.215a6.66 6.66 0 0 1-.965 3.453 7.02 7.02 0 0 1-2.488 2.54A6.889 6.889 0 0 1 15 18.53c-1.27 0-2.438-.304-3.453-.914a6.771 6.771 0 0 1-2.54-2.539c-.609-1.015-.913-2.183-.913-3.453 0-1.117.254-2.234.812-3.25 0 .813.254 1.473.813 2.031.558.559 1.219.813 2.031.813.762 0 1.422-.254 1.98-.813.56-.558.864-1.219.864-2.031 0-.762-.305-1.422-.813-1.98a13.89 13.89 0 0 0-6.347 2.132c-1.93 1.22-3.504 2.793-4.622 4.723 1.22 2.133 2.946 3.809 5.079 5.027 2.132 1.27 4.52 1.88 7.109 1.88Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eyeGalleryOpen_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v27H0z"
  })))));
};

export default SvgEyeGalleryOpen;